export default __webpack_public_path__ + "static/media/courseDesktop.b6053112.png";